module.exports = __webpack_public_path__ + "static/img/xi.5789433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/xi.jpg
// module id = OtC8
// module chunks = 0